import NclayerPort from "./NclayerPort";

const nclayerPort = new NclayerPort();

export default nclayerPort;
export { NclayerPort };
